<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/customer/table">客户管理({{customer.name}})</el-breadcrumb-item>
        <el-breadcrumb-item :to="`/project/table/${customer.id}`">项目管理({{project.name}})</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :show-header="false">
      <h2>{{project.name}}( ID:{{project.id}} ) 项目明细</h2>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>

      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="30"></el-table-column>
        <el-table-column prop="updatetime"
                         label="更新时间"
                         min-width="120"></el-table-column>
        <el-table-column prop="userid"
                         label="操作人ID"
                         min-width="50"></el-table-column>
        <el-table-column prop="username"
                         label="操作人"
                         min-width="80"></el-table-column>
        <el-table-column prop="description"
                         label="操作内容"
                         min-width="190">
          <template slot-scope="scope">
            {{scope.row.description === 'BU审批通过' ? 'BO审批通过' : scope.row.description}}
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'

export default {
  mixins: [table],
  data () {
    return {
      customer: {
        id: this.$route.params.customerid,
        name: null
      },
      project: {
        id: this.$route.params.id,
        name: null
      },
      exportHeader: [
        {
          key: 'id',
          text: '页面名称ID',
        },
        {
          key: 'name',
          text: '页面名称名称',
        },
        {
          key: 'created_at',
          text: '添加日期',
        },
      ],
    }
  },
  computed: Vuex.mapState({}),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      this.setProject()
      this.setCustomer()
      params.projectid = this.$route.params.id
      return request.common('getProjectFlowTable', params)
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.exportHeader,
      })
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
    onExportRows (id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: (params) => request('exportViewNameData', params),
        requestParams: {id},
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    onDelete (index, rows) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('deleteViewNameData', {id: rows[index].id}).then(() => {
          this.$message.success('删除成功')
          rows.splice(index, 1)
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    setProject () {
      request.common('getProjectDetail', {id: this.$route.params.id}).then(({data}) => {
        this.project = data
      })
    },
    setCustomer () {
      request.common('getCustomerDetail', {id: this.$route.params.customerid}).then(({data}) => {
        this.customer = data
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/customer-project/pages/ProjectFlowTable.vue